import React, { useState, useCallback, useEffect, useRef } from 'react';
import useApi from '../../api/useApi';

function index({ selectedDevice, handleClose, notification, refreshList, status }) {
  const orgId = JSON.parse(sessionStorage.user).organization.id;
  const { userId } = JSON.parse(sessionStorage.user).user;
  const formModel = {
    deviceId: selectedDevice,
    gatewayType: '',
    _warehouse: null,
    zoneId: '',
    longitude: '',
    latitude: '',
    attributes: null,
    createdBy: userId,
  };

  const [formData, setFormData] = useState(formModel);
  const [attributes, setAttributes] = useState();
  const [projects, setProjects] = useState([]);
  const [device, setDevices] = useState([]);
  const [zones, setZones] = useState([]);
  const [selectedWarehouse, selectWarehouse] = useState(null);
  const [warehouseList, setWarehouseList] = useState([]);

  const [{ isLoading, isError, data }, postData] = useApi();
  const [projectRes, getProject] = useApi();
  const [deviceRes, getDevice] = useApi();
  const [warehouseRes, getWarehouses] = useApi();
  const [zonesRes, getZones] = useApi();
  const [getEdit, getEditDevice] = useApi();
  const [floormapState, uploadFloormap] = useApi();

  const key = useRef(null);
  const value = useRef(null);
  const [floorMap, setFloorMap] = useState('');
  const [provisionType, setProvisionType] = useState('Warehouse');

  useEffect(() => {
    getProject(`/organization/${orgId}/projects`, 'GET');
    getDevice(`/organization/${orgId}/devices`, 'GET');
    getWarehouses(`/organization/${orgId}/warehouses`, 'GET');
    getZones(`/organization/${orgId}/zones`, 'GET');
  }, []);

  useEffect(() => {
    getEditDevice(`/device/${selectedDevice}/gateway`, 'GET');
    getDevice(`/organization/${orgId}/devices`, 'GET');
  }, [selectedDevice]);

  useEffect(() => {
    if (!projectRes.isLoading && !projectRes.isError && projectRes.data) {
      setProjects(projectRes.data.projects);
    }
  }, [projectRes]);

  useEffect(() => {
    if (!getEdit.isLoading && !getEdit.isError && getEdit.data) {
      setFormData({
        deviceId: selectedDevice,
        gatewayType: getEdit.data.gatewayInfo?.gatewayType,
        _warehouse: getEdit.data.gatewayInfo?.Zone?.Warehouse?.name,
        zoneId: getEdit.data.gatewayInfo?.Zone?.name,
        longitude: getEdit.data.gatewayInfo?.longitude,
        latitude: getEdit.data.gatewayInfo?.latitude,
        attributes: null,
        createdBy: userId,
        location: getEdit.data.gatewayInfo?.location,
      });

      if (getEdit.data.gatewayInfo?.projectId) {
        setProvisionType('Warehouse');
      } else {
        setProvisionType('Zone');
      }

      warehouseList.forEach((warehouse) => {
        if (warehouse.name === getEdit.data.gatewayInfo?.Zone?.Warehouse?.name) {
          selectWarehouse(warehouse);
        }
      });
    }
  }, [getEdit, warehouseList]);

  useEffect(() => {
    if (!zonesRes.isLoading && !zonesRes.isError && zonesRes.data) {
      const zonesFiltered = zonesRes.data.filter((zone) => zone.location !== null);

      const _zones =
        zonesFiltered &&
        zonesFiltered.length > 0 &&
        zonesFiltered.sort((a, b) => (a.location.toLowerCase() > b.location.toLowerCase() ? 1 : -1));

      setZones(_zones);
    }
  }, [zonesRes]);

  useEffect(() => {
    if (!warehouseRes.isLoading && !warehouseRes.isError && warehouseRes.data) {
      setWarehouseList(warehouseRes.data.warehouses);
    }
  }, [warehouseRes]);

  useEffect(() => {
    if (!deviceRes.isLoading && !deviceRes.isError && deviceRes.data) {
      const deviceArray = deviceRes.data.devices.filter((data) => {
        if (data?.device?.isActive || data?.isActive) {
          if (
            data?.deviceType === 'BLE_GW' ||
            data?.device?.deviceType === 'BLE_GW' ||
            data?.deviceType === 'PHONE_GW' ||
            data?.device?.deviceType === 'PHONE_GW'
          ) {
            return data;
          }
        }
      });
      setDevices(deviceArray);
    }
  }, [deviceRes]);

  const getId = (name) => {
    let _zone = [];
    if (provisionType === 'Warehouse') {
      _zone = selectedWarehouse.Zones.filter((item) => item.name === name);
    } else {
      _zone = zones.filter((item) => item.name);
    }

    return _zone[0].id;
  };

  const handleInputChange = useCallback((e) => {
    if (e.target.name === 'location') {
      zones &&
        zones.length > 0 &&
        zones.forEach((zone) => {
          if (zone.location === e.target.value) {
            formData.latitude = zone.gateways[0].latitude;
            formData.longitude = zone.gateways[0].longitude;
          }
        });
    }

    if (e.target.name === 'zoneId') {
      const lng = selectedWarehouse.Address.longitude;
      const lat = selectedWarehouse.Address.latitude;
      formData.latitude = lat;
      formData.longitude = lng;
    }
    if (e.target.name === '_warehouse') {
      formData.zoneId = '';
      warehouseList.forEach((warehouse) => {
        if (warehouse.name === e.target.value) {
          selectWarehouse(warehouse);
        }
      });
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    let body;
    if (provisionType === 'Warehouse') {
      body = {
        ...formData,
        deviceId: formData.deviceId,
        zoneId: getId(formData.zoneId),
        attributes,
      };
    } else {
      body = {
        ...formData,
        attributes,
        _warehouse: null,
        zoneId: null,
      };
    }
    if (status === 'Inactive') {
      postData(`/device/${formData.deviceId}/gateway`, 'POST', body);
    } else {
      postData(`/device/${formData.deviceId}/gateway`, 'PATCH', body);
    }
  };

  const handleAddAttributes = () => {
    const x = { ...attributes };
    const k = key.current.value;
    const v = value.current.value;

    x[k] = v;
    setAttributes(x);
  };

  const deleteAttribute = (item) => {
    const attr = { ...attributes };
    delete attr[item[0]];

    setAttributes(attr);
  };

  useEffect(() => {
    key.current.value = '';
    value.current.value = '';
  }, [attributes]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      notification('success', `Gateway provisioned successfully`);
      if (floorMap) {
        const x = new FormData();
        x.append('file', floorMap, floorMap.name);
        uploadFloormap(`/device/${selectedDevice}/floorPlan`, 'POST', x);
      }
      handleClose();
      refreshList();
    }
    if (isError) {
      notification('error', data);
      handleClose();
      // refreshList(s);
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (!floormapState.isLoading && !floormapState.isError && floormapState.data) {
      handleClose();
    }
  }, [floormapState]);

  return (
    <div
      className="flex justify-center items-center h-full w-full fixed z-20"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
    >
      <div className="bg-white w-2/4  pt-1 relative rounded-2xl mobile_toggle">
        <img
          src="assets/img/Close.svg"
          className="absolute top-6 right-6 h-3 cursor-pointer"
          alt=""
          onClick={handleClose}
        />
        <p className="font-bold text-sm text-textBlue1 border-b p-4 pl-6">
          {status === 'Inactive' ? 'Provision Gateway' : 'Update Gateway'}
        </p>
        {/* <p className="font-bold text-lg text-textBlue1">CREATE GATEWAY</p> */}
        {selectedDevice && getEdit.isLoading ? (
          <img src="assets/img/loader.svg" className="w-16 m-auto" alt="" />
        ) : (
          <form className="mt-2 mb-2 mx-10 grid grid-cols-2 gap-x-8 " onSubmit={handleSubmit} autoComplete="off">
            <div className="mt-5 w-full relative ">
              <input
                type="text"
                placeHolder="Gateway Id"
                value={formData.deviceId}
                autoComplete="off"
                name="deviceId"
                list="deviceId"
                readOnly="readonly"
                className="inputLabelText px-4 py-2 focus:outline-none back-dim "
                onChange={handleInputChange}
              />
              <datalist id="deviceId">
                {device.map((item) => (
                  <option key={item?.device ? item?.device?.id : item?.id}>
                    {item?.device ? item?.device?.id : item?.id}
                  </option>
                ))}
              </datalist>
            </div>

            <div className="mt-5 w-full relative">
              <div className="px-4 py-2 focus:outline-none inputLabelText">
                <select
                  value={formData.gatewayType}
                  name="gatewayType"
                  autoComplete="off"
                  className="border-none w-full focus:outline-none text-sm text-parameter border "
                  onChange={handleInputChange}
                  required
                >
                  <option>Select Gateway Type</option>
                  <option value="BLE_GW">GENERIC</option>
                  <option>ANDROID</option>
                  <option>IOS</option>
                  <option>LAIRD</option>
                  <option>MERAKI</option>
                  <option>MOBILOGIX</option>
                  <option>QUUPPA</option>
                  <option>ROAMBEE</option>
                  <option>SYSTECH</option>
                </select>
              </div>
            </div>

            <div className="mt-5 w-full relative">
              <div className="px-4 py-2 focus:outline-none inputLabelText">
                <select
                  value={provisionType}
                  name="provisionType"
                  autoComplete="off"
                  className="border-none w-full focus:outline-none text-sm text-parameter border "
                  onChange={(e) => setProvisionType(e.target.value)}
                >
                  <option>Provision Using</option>
                  <option>Warehouse</option>
                  <option>Zone</option>
                </select>
              </div>
            </div>

            {provisionType === 'Warehouse' ? (
              <div className="col-span-2 grid grid-cols-2 gap-x-8">
                <div className="mt-5 w-full relative">
                  <div className="px-4 py-2 focus:outline-none inputLabelText">
                    <select
                      placeholder="Warehouse"
                      value={formData._warehouse}
                      name="_warehouse"
                      autoComplete="off"
                      className="border-none w-full focus:outline-none text-sm text-parameter border "
                      onChange={handleInputChange}
                    >
                      <option>Select Warehouse</option>
                      {warehouseList.map((item) => (
                        <option>{item?.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="mt-5 w-full relative">
                  <div className="px-4 py-2 focus:outline-none inputLabelText">
                    <select
                      placeholder="Zone"
                      value={formData.zoneId}
                      name="zoneId"
                      autoComplete="off"
                      className="border-none w-full focus:outline-none text-sm text-parameter border "
                      onChange={handleInputChange}
                      disabled={
                        zones.length === 0 &&
                        selectedWarehouse &&
                        selectedWarehouse.Zones &&
                        selectedWarehouse.Zones.length === 0
                      }
                      required
                    >
                      <option>Select Zone</option>
                      {selectedWarehouse && selectedWarehouse.Zones.map((item) => <option>{item?.name}</option>)}
                    </select>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="mt-5 w-full relative">
                  {/* <label htmlFor="shortName" className="block text-parameter w-1/3 text-sm">
            ZONE
          </label> */}
                  <input
                    type="text"
                    placeholder="Zone"
                    value={formData.location}
                    name="location"
                    list="zones"
                    autoComplete="off"
                    className="inputLabelText px-4 py-2 focus:outline-none"
                    onChange={handleInputChange}
                    required
                  />
                  <datalist id="zones">
                    {zones &&
                      zones.length > 0 &&
                      zones.map((item) => <option key={item?.location}>{item?.location}</option>)}
                  </datalist>
                </div>
              </>
            )}

            <div className="mt-5 w-full relative">
              {/* <label htmlFor="shortName" className="block text-parameter w-1/3 text-sm">
              LATITUDE
            </label> */}
              <input
                type="text"
                placeholder="Latitude"
                value={formData.latitude}
                name="latitude"
                autoComplete="off"
                className="inputLabelText px-4 py-2 focus:outline-none"
                onChange={handleInputChange}
              />
            </div>
            <div className="mt-5 w-full relative">
              {/* <label htmlFor="shortName" className="block text-parameter w-1/3 text-sm">
              LONGITUDE
            </label> */}
              <input
                type="text"
                placeholder="Longitude"
                value={formData.longitude}
                name="longitude"
                autoComplete="off"
                className="inputLabelText px-4 py-2 focus:outline-none"
                onChange={handleInputChange}
              />
            </div>
            <p className="mt-5 w-full text-xs font-bold col-span-2">ATTRIBUTES</p>

            <div className="relative grid grid-cols-2 gap-x-8 col-span-2 w-full">
              <div className="mt-5 w-full">
                {/* <label htmlFor="website" className="block text-parameter w-1/3 text-sm mr-2">
                KEY
              </label> */}
                <input
                  type="text"
                  ref={key}
                  placeHolder="Key"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                />
              </div>

              <div className="mt-5 w-full">
                {/* <label htmlFor="city" className="block text-parameter w-1/3 text-sm mr-2">
                VALUE
              </label> */}
                <input
                  type="text"
                  ref={value}
                  placeHolder="value"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                />
              </div>

              <img
                src="assets/img/Add.svg"
                className="absolute -right-8 h-6 top-7 cursor-pointer"
                alt=""
                onClick={handleAddAttributes}
              />
            </div>

            <div className="w-full flex col-span-2">
              {attributes &&
                Object.entries(attributes).map((item) => (
                  <p
                    className="text-black py-1 px-4 rounded-full border mx-2 cursor-pointer"
                    onClick={() => deleteAttribute(item)}
                  >
                    {item.join(' - ')}
                  </p>
                ))}
            </div>

            {/* <div className="inputLabelText px-4 py-2 mt-6 h-32 w-full"></div> */}
            {/* <div className="w-full relative">
            <div className="flex items-center">
              <div
                className="mt-6 text-center py-2 rounded-md bg-primary w-full text-white"
                onClick={() => fileRef.current.click()}
              >
                Upload Floor Map
              </div>
              <span className="mt-5 ml-6">{floorMap.name}</span>
              <input ref={fileRef} onChange={handleChange} multiple={false} type="file" hidden />
              {floormapState.isLoading && (
                <img src="assets/img/loader.svg" className="w-16 transform translate-y-3" alt="" />
              )}
            </div>
          </div> */}

            <div className="w-1/2 mt-5 mb-2 relative ml-auto col-span-2">
              {isLoading ? (
                <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto bottom-0" alt="" />
              ) : (
                <div className="flex text-xs">
                  <button
                    type="submit"
                    onClick={() => handleClose()}
                    className="rounded-3xl w-1/2  border focus:outline-none  h-10 mr-3 cursor-pointer "
                    // style={{ border: '1px solid #16406D' }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="rounded-3xl w-1/2 focus:outline-none h-10 text-white bg-primary cursor-pointer "
                    style={{ border: '1px solid #16406D' }}
                  >
                    Save
                  </button>
                </div>
              )}
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default index;
